var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3167 5.98333C28.6833 5.35 27.8333 5 26.95 5H8.33333C7.44928 5 6.60143 5.35119 5.97631 5.97631C5.35119 6.60143 5 7.44928 5 8.33333V31.6667C5 33.5 6.5 35 8.33333 35H31.6667C33.5 35 35 33.5 35 31.6667V13.05C35 12.1667 34.65 11.3167 34.0167 10.7L29.3167 5.98333ZM20 31.6667C17.2333 31.6667 15 29.4333 15 26.6667C15 23.9 17.2333 21.6667 20 21.6667C22.7667 21.6667 25 23.9 25 26.6667C25 29.4333 22.7667 31.6667 20 31.6667ZM21.6667 15H11.6667C9.83333 15 8.33333 13.5 8.33333 11.6667C8.33333 9.83333 9.83333 8.33333 11.6667 8.33333H21.6667C23.5 8.33333 25 9.83333 25 11.6667C25 13.5 23.5 15 21.6667 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundSave);
export default __webpack_public_path__ + "static/media/ic_round-save.0571d50a362cb306e64bdc570abba1a3.svg";
export { ForwardRef as ReactComponent };